import { isToggle } from 'src/types/columnFlags';
import { make } from 'vuex-pathify';
import makeTableCommonActions from '../../utils/vuexModuleConstructor/vuexTableCommonActionsMaker';
import makeTableCommonGetters from '../../utils/vuexModuleConstructor/vuexTableCommonGettersMaker';
import makeTableCommonState from '../../utils/vuexModuleConstructor/vuexTableCommonStateMaker';
const remoteEntityName = 'preferences.options';
const state = Object.assign({}, makeTableCommonState());
const getters = Object.assign(Object.assign({}, makeTableCommonGetters({ remoteEntityName })), { pageTitle: () => 'Preferences: options', controlledActions: () => {
        return {
            create: -1,
            fetch: 1,
            update: -1,
            delete: -1,
            downloadList: -1,
            uploadList: -1
        };
    }, columns: () => {
        return [
            { name: 'id', label: 'ID', style: 'width:50px', field: 'id', align: 'left', hideWhenCreating: true, isNumeric: true },
            { name: 'name', label: 'Name', field: 'name', inlineEdit: true, align: 'left', required: true },
            { name: 'parent_id' },
            { name: 'content' },
            { name: 'can_be_user_specific', isToggle },
            { name: 'hide_from_ui_display', isToggle },
            { name: 'display_as_percent', isToggle }
        ];
    } });
const mutations = make.mutations(state);
const namespaced = true;
const actions = Object.assign({}, makeTableCommonActions());
export default { state, actions, mutations, getters, namespaced };
